<template>
  <div class="login-container">
    <div class="logo-wrapper">
      <img
        src="https://www.spectatorguides.app/wp-content/uploads/2025/05/Spectator-Guides-1080-200-Black-Clear.webp"
        alt="Spectator Guides Logo"
        class="login-logo"
        width="300"
        height="auto"
      />
    </div>

    <h1>Admin Login</h1>

    <form @submit.prevent="handleLogin">
      <input v-model="email" type="email" placeholder="Email" required />
      <input v-model="password" type="password" placeholder="Password" required />
      <button type="submit" :disabled="loading">
        {{ loading ? 'Logging in...' : 'Login' }}
      </button>
      <p class="error" v-if="error">{{ error }}</p>
    </form>
  </div>
</template>

<script>
import { ref } from 'vue';
import { useRouter } from 'vue-router';
import { signInWithEmailAndPassword } from 'firebase/auth';
import { doc, getDoc } from 'firebase/firestore';
import { auth, db } from '../firebase'; // Make sure db is exported from firebase.js

export default {
  name: 'LoginView',
  setup() {
    const email = ref('');
    const password = ref('');
    const error = ref('');
    const loading = ref(false);
    const router = useRouter();

    const handleLogin = async () => {
      loading.value = true;
      error.value = '';

      try {
        await signInWithEmailAndPassword(auth, email.value, password.value);

        // 🔐 Fetch 2FA secret from Firestore
        const userDoc = doc(db, 'twofa', email.value);
        const snapshot = await getDoc(userDoc);

        if (!snapshot.exists()) {
          error.value = '2FA not set up for this account.';
          loading.value = false;
          return;
        }

        const secret = snapshot.data().secret;
        sessionStorage.setItem('2faSecret', secret);
        sessionStorage.setItem('2faVerified', 'false');

        router.push('/2fa');
      } catch (err) {
        error.value = err.message;
      } finally {
        loading.value = false;
      }
    };

    return { email, password, error, loading, handleLogin };
  }
};
</script>

<style scoped>
.login-container {
  max-width: 400px;
  margin: 80px auto;
  padding: 40px;
  text-align: center;
}

.logo-wrapper {
  margin-bottom: 20px;
}

.login-logo {
  max-width: 100%;
  height: auto;
}

form {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

input {
  padding: 10px;
  font-size: 1rem;
}

button {
  padding: 10px;
  font-size: 1rem;
  background-color: #3dc31f;
  color: white;
  border: none;
  cursor: pointer;
}

button[disabled] {
  opacity: 0.6;
  cursor: not-allowed;
}

.error {
  color: red;
  margin-top: 10px;
}
</style>